var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 37 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#064e3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.098 21.031-9.771 9.763-9.425-9.354a.5.5 0 0 0-.705.709l9.778 9.706a.5.5 0 0 0 .706-.001l10.124-10.115a.5.5 0 0 0-.707-.708zM20.253 2.862c-.046.048-.938.987-1.676 2.54a9.58 9.58 0 0 0-1.838-2.548c-3.823-3.799-10.045-3.798-13.866 0C1.021 4.696 0 7.146 0 9.75s1.021 5.053 2.873 6.894a.5.5 0 0 0 .705-.709A8.666 8.666 0 0 1 1 9.75a8.67 8.67 0 0 1 2.578-6.187c3.433-3.412 9.021-3.412 12.456 0 .938.933 1.638 1.942 2.079 3.206.07.2.259.231.472.231h.002c.214 0 .403-.033.472-.235.682-2.008 1.903-3.25 1.907-3.254 3.433-3.412 9.021-3.386 12.456.026A8.7 8.7 0 0 1 36 9.737a8.678 8.678 0 0 1-2.578 6.191.505.505 0 0 0 .352.859.5.5 0 0 0 .353-.145C35.979 14.802 37 12.354 37 9.75s-1.021-5.054-2.873-6.895c-3.823-3.801-10.045-3.798-13.874.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 18H24.431a.502.502 0 0 0-.425.235l-1.99 3.194-2.534-8.739a.499.499 0 0 0-.932-.073l-3.272 6.962-1.942-3.947a.498.498 0 0 0-.82-.113L10.29 18H1.5a.5.5 0 0 0 0 1h9.014c.143 0 .277-.09.372-.195l1.878-2.126 2.074 4.158c.084.171.258.163.448.163h.005c.191 0 .366.003.447-.171l3.151-6.587 2.478 8.542a.502.502 0 0 0 .905.125L24.708 19H35.5a.5.5 0 0 0 0-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBeat);
export default __webpack_public_path__ + "static/media/Heart-Beat.2a0c54e22a89a1ab79e81610a3d1bff2.svg";
export { ForwardRef as ReactComponent };